/**
 * Field-diff table body for the Quick Review detail modal.
 * @module quickReviewModalBody
 */
import { useEffect, useState } from "react";
import { QuickReviewFieldComparison } from "../../../data-model/quickReviewModel";
import { TableNames } from "../../../enums/tableNames";
import CustomTable from "../../custom-table/custom-table";
import {
    QuickReviewDiffTableData,
    QuickReviewDiffTableUtils
} from "./utils/quickReviewDiffTable";

/** Props for {@link QuickReviewModalBody}. */
interface QuickReviewModalBodyProps {
    /** Every monitored field comparison from the Quick Review detail response */
    fields: QuickReviewFieldComparison[];
}

/**
 * Field-diff table for one boarded Quick Review order: each monitored field
 * with the value the order was worked in against the newly ingested value.
 *
 * @param props - {@link QuickReviewModalBodyProps}
 * @returns Diff table of worked vs newly ingested field values
 */
const QuickReviewModalBody = ({ fields }: QuickReviewModalBodyProps) => {
    const [tableData, setTableData] = useState<QuickReviewDiffTableData[]>([]);

    useEffect(() => {
        setTableData(
            QuickReviewDiffTableUtils.generateTableDataFromFieldComparisons(fields),
        );
    }, [fields]);

    return (
        <div className="h-full">
            <CustomTable
                tableHeaders={QuickReviewDiffTableUtils.generateColumnsForQuickReviewDiffTable()}
                tableData={tableData}
                tableName={TableNames.QUICK_REVIEW_DIFF_TABLE}
                count={tableData.length}
                totalCount={tableData.length}
                hideSearchBar
                hidePagination
                pagesPerView={tableData.length}
                itemsPerPage={tableData.length}
            />
        </div>
    );
};

export default QuickReviewModalBody;
